import { Commands, RouteContext } from '@vaadin/router';
import { pageEnabled } from './authGuard';

import { COMPANY_USER_TAG_NAME } from '@treasury/domain-components/company-user/company-user.component.data';
import { COMPANY_USER_LIST_TAG_NAME } from '@treasury/domain-components/company-users/company-users.types';
import { FORGOT_PASSWORD_TAG_NAME } from '@treasury/domain-components/login/components/forgot-password.data';
import { SSO_CALLBACK_CONTAINER_TAG_NAME } from '@treasury/domain-components/login/sso-callback-container.data';
import { UIS_CONTAINER_TAG_NAME } from '@treasury/domain-components/login/uis-container.data';
import { TERMS_AND_CONDITIONS_TAG_NAME } from '@treasury/domain-components/terms-and-conditions/container.data';
import { ABOUT_CONTAINER_TAG_NAME } from '../about/containers/about-container.data';
import { ACCOUNT_RECON_LIBRARY_CONTAINER_TAG_NAME } from '../account-recon/containers/account-recon-library-container.data';
import { ACCOUNT_RECON_REPORTS_CONTAINER_TAG_NAME } from '../account-recon/containers/account-recon-reports-container.data';
import { ACCOUNT_RECON_WORKFLOW_CONTAINER_TAG_NAME } from '../account-recon/containers/account-recon-workflow-container.data';
import { ACCOUNT_CONTAINER_TAG_NAME } from '../accounts/containers/account-container.data';
import { ACCOUNTS_CONTAINER_TAG_NAME } from '../accounts/containers/accounts-container.data';
import { ACCOUNTS_RESEARCH_TRANSACTIONS_CONTAINER_TAG_NAME } from '../accounts/containers/accounts-research-transactions-container.data';
import { AGILETICS_WEB_ESCROW_CONTAINER_TAG_NAME } from '../accounts/containers/agiletics-web-escrow-container.data';
import { CHILD_SUPPORT_PAYMENT_CONTAINER_TAG_NAME } from '../ach/child-support/containers/child-support-payment-container.data';
import { CHILD_SUPPORT_PAYMENTS_CONTAINER_TAG_NAME } from '../ach/child-support/containers/child-support-payments-container.data';
import { CHILD_SUPPORT_TEMPLATE_CONTAINER_TAG_NAME } from '../ach/child-support/containers/child-support-template-container.data';
import { CHILD_SUPPORT_TEMPLATES_CONTAINER_TAG_NAME } from '../ach/child-support/containers/child-support-templates-container.data';
import { CHILD_SUPPORT_WORKFLOW_CONTAINER_TAG_NAME } from '../ach/child-support/containers/child-support-workflow-container.data';
import { ACH_MANUAL_BATCH_CONTAINER_TAG_NAME } from '../ach/containers/ach-manual-batch-container.data';
import { ACH_MASTER_RECIPIENTS_CONTAINER_TAG_NAME } from '../ach/containers/ach-master-recipients-container.data';
import { ACH_PAYMENT_CONTAINER_TAG_NAME } from '../ach/containers/ach-payment-container.data';
import { ACH_PAYMENTS_CONTAINER_TAG_NAME } from '../ach/containers/ach-payments-container.data';
import { ACH_REVERSAL_CONTAINER_TAG_NAME } from '../ach/containers/ach-reversal-container.data';
import { ACH_TEMPLATE_CONTAINER_TAG_NAME } from '../ach/containers/ach-template-container.data';
import { ACH_TEMPLATES_CONTAINER_TAG_NAME } from '../ach/containers/ach-templates-container.data';
import { ACH_WORKFLOW_CONTAINER_TAG_NAME } from '../ach/containers/ach-workflow-container.data';
import { ACH_IMPORT_LAYOUT_CONTAINER_TAG_NAME } from '../ach/import-layout/containers/ach-import-layout-container.data';
import { TAX_INITIATE_CONTAINER_TAG_NAME } from '../ach/tax-payments/containers/tax-initiate-container.data';
import { TAX_PAYMENT_WORKFLOW_CONTAINER_TAG_NAME } from '../ach/tax-payments/containers/tax-payment-workflow-container.data';
import { TAX_TEMPLATE_WORKFLOW_CONTAINER_TAG_NAME } from '../ach/tax-payments/containers/tax-template-workflow-container.data';
import { ACCOUNT_NICKNAMES_CONTAINER_TAG_NAME } from '../admin/containers/account-nicknames-container.data';
import { ISSUED_ITEMS_ACTIVITY_CONTAINER_TAG_NAME } from '../arp/issued-items-activity/containers/issued-items-activity-container.data';
import { ISSUED_ITEMS_CREATE_CONTAINER_TAG_NAME } from '../arp/issued-items-create/containers/issued-items-create-container.data';
import { ISSUED_ITEMS_FILE_ACTIVITY_CONTAINER_TAG_NAME } from '../arp/issued-items-file-activity/containers/issued-items-file-activity-container.data';
import { BUSINESS_BILL_PAY_CONTAINER_TAG_NAME } from '../business-bill-pay/containers/business-bill-pay-container.data';
import { BUSINESS_BILL_PAY_PAYEE_DETAIL_CONTAINER_TAG_NAME } from '../business-bill-pay/containers/business-bill-pay-payee-detail-container.data';
import { BUSINESS_BILL_PAY_PAYEES_CONTAINER_TAG_NAME } from '../business-bill-pay/containers/business-bill-pay-payees-container.data';
import { BUSINESS_BILL_PAY_PAYMENT_DETAIL_CONTAINER_TAG_NAME } from '../business-bill-pay/containers/business-bill-pay-payment-detail-container.data';
import { BUSINESS_BILL_PAY_WORKFLOW_CONTAINER_TAG_NAME } from '../business-bill-pay/containers/business-bill-pay-workflow-container.data';
import { JHD_LAYOUT_TAG_NAME } from '../components/jhd-layout.data';
import { NOT_FOUND_TAG_NAME } from '../components/not-found.data';
import { JHD_DASHBOARD_TAG_NAME } from '../dashboard/containers/dashboard.data';
import { DEPOSIT_ACTIVITY_CONTAINER_TAG_NAME } from '../deposits/containers/deposit-activity-container.data';
import { DEPOSIT_CONTAINER_TAG_NAME } from '../deposits/containers/deposit-container.data';
import { LOAN_CONTAINER_TAG_NAME } from '../loans/containers/loan-container.data';
import { LOAN_WORKFLOW_CONTAINER_TAG_NAME } from '../loans/containers/loan-workflow-container.data';
import { LOANS_CONTAINER_TAG_NAME } from '../loans/containers/loans-container.data';
import { LOGGED_OUT_CONTAINER_TAG_NAME } from '../logout/containers/logged-out-container.data';
import { LOGOUT_CONTAINER_TAG_NAME } from '../logout/containers/logout-container.data';
import { COMPOSE_MESSAGE_CONTAINER_TAG_NAME } from '../message-center/containers/compose-message-container.data';
import { MESSAGE_CENTER_CONTAINER_TAG_NAME } from '../message-center/containers/message-center-container.data';
import { NOTIFICATIONS_CONTAINER_TAG_NAME } from '../notifications/containers/notifications-container.data';
import { PENDING_APPROVALS_CONTAINER_TAG_NAME } from '../pending-approvals/containers/pending-approvals-container.data';
import { ACH_EXCEPTIONS_CONTAINER_TAG_NAME } from '../positive-pay/ach-exceptions/containers/ach-exceptions-container.data';
import { ACH_FILTER_WORKFLOW_CONTAINER_TAG_NAME } from '../positive-pay/ach-exceptions/containers/ach-filter-workflow-container.data';
import { CENTRIX_SSO_CONTAINER_TAG_NAME } from '../positive-pay/centrix-sso/containers/centrix-sso-container.data';
import { CHECK_EXCEPTION_DETAIL_CONTAINER_TAG_NAME } from '../positive-pay/check-exceptions/containers/check-exception-detail-container.data';
import { CHECK_EXCEPTIONS_CONTAINER_TAG_NAME } from '../positive-pay/check-exceptions/containers/check-exceptions-container.data';
import { USER_PROFILE_CONTAINER_TAG_NAME } from '../profile/containers/user-profile-container.data';
import { REPORT_CONTAINER_TAG_NAME } from '../reports/containers/report-container.data';
import { ELECTRONIC_DOCUMENTS_CONTAINER_TAG_NAME } from '../reports/electronic-documents/electronic-documents-container.data';

import { DiContainer } from '@jkhy/frontend-utils/di/di-container';
import { FeatureFlagService } from '@treasury/domain/services/feature-flags/feature-flag.service';
import { Feature } from '@treasury/domain/services/feature-flags/feature-flag.types';
import { REPORT_LAYOUT_TAG_NAME } from '../reports/partials/report-layout.data';
import { STOP_PAYMENT_ACTIVITY_CONTAINER_TAG_NAME } from '../stop-payments/containers/stop-payment-activity-container.data';
import { STOP_PAYMENT_WORKFLOW_CONTAINER_TAG_NAME } from '../stop-payments/containers/stop-payment-workflow-container.data';
import { TRANSACTION_CONTAINER_TAG_NAME } from '../transaction/containers/transaction.data';
import { TRANSFER_TEMPLATE_CONTAINER_TAG_NAME } from '../transfers/containers/transfer-template-container.data';
import { TRANSFER_TEMPLATES_CONTAINER_TAG_NAME } from '../transfers/containers/transfer-templates-container.data';
import { TRANSFER_WORKFLOW_CONTAINER_TAG_NAME } from '../transfers/containers/transfer-workflow-container.data';
import { TRANSFERS_CONTAINER_TAG_NAME } from '../transfers/containers/transfers-container.data';
import { USER_CONTAINER_TAG_NAME } from '../users/containers/user-container.data';
import { CORPAY_SSO_CONTAINER_TAG_NAME } from '../wires/containers/corpay-sso-container.data';
import { WIRE_CONTAINER_TAG_NAME } from '../wires/containers/wire-container.data';
import { WIRE_FILE_UPLOAD_WORKFLOW_CONTAINER_TAG_NAME } from '../wires/containers/wire-file-upload-workflow-container.data';
import { WIRE_FILES_CONTAINER_TAG_NAME } from '../wires/containers/wire-files-container.data';
import { WIRE_UPLOAD_FORMAT_CONTAINER_TAG_NAME } from '../wires/containers/wire-upload-format-container.data';
import {
    JH_WIRES_CONTAINER_TAG_NAME,
    WIRES_CONTAINER_TAG_NAME,
} from '../wires/containers/wires-container.data';
import { WIRES_FX_WORKFLOW_CONTAINER_TAG_NAME } from '../wires/containers/wires-fx-workflow-container.data';
import { WIRES_MULTIPLE_WORKFLOW_CONTAINER_TAG_NAME } from '../wires/containers/wires-multiple-workflow-container.data';
import {
    JH_WIRES_WORKFLOW_CONTAINER_TAG_NAME,
    WIRES_WORKFLOW_CONTAINER_TAG_NAME,
} from '../wires/containers/wires-workflow-container.data';
import { CREDITOR_CONTAINER_TAG_NAME } from '../wires/creditors/containers/creditor-container.data';
import { CREDITOR_WORKFLOW_CONTAINER_TAG_NAME } from '../wires/creditors/containers/creditor-workflow-container.data';
import { CREDITORS_CONTAINER_TAG_NAME } from '../wires/creditors/containers/creditors-container.data';
import { WIRE_TEMPLATE_CONTAINER_TAG_NAME } from '../wires/templates/containers/wire-template-container.data';
import { WIRE_TEMPLATE_WORKFLOW_CONTAINER_TAG_NAME } from '../wires/templates/containers/wire-template-workflow-container.data';
import { WIRE_TEMPLATES_CONTAINER_TAG_NAME } from '../wires/templates/containers/wire-templates-container.data';

export const routes = [
    {
        path: '/:institution/login',
        component: UIS_CONTAINER_TAG_NAME,
        action: async () => {
            await import('@treasury/domain-components/login/uis-container');
        },
    },
    {
        path: '/:institution/login/sso',
        component: SSO_CALLBACK_CONTAINER_TAG_NAME,
        action: async () => {
            await import('@treasury/domain-components/login/sso-callback-container');
        },
    },
    {
        path: '/:institution/login/bff',
        component: SSO_CALLBACK_CONTAINER_TAG_NAME,
        action: async () => {
            await import('@treasury/domain-components/login/sso-callback-container');
        },
    },
    {
        path: '/:institution/forgot-password',
        component: FORGOT_PASSWORD_TAG_NAME,
        action: async () => {
            await import('@treasury/domain-components/login/components/forgot-password');
        },
    },
    {
        path: '/:institution/log-out/confirmed',
        component: LOGGED_OUT_CONTAINER_TAG_NAME,
        action: async () => {
            await import('../logout/containers/logged-out-container');
        },
    },
    {
        path: '/:institution/terms-and-conditions-accept',
        component: TERMS_AND_CONDITIONS_TAG_NAME,
        action: async () => {
            await import('@treasury/domain-components/terms-and-conditions/container');
        },
    },
    {
        path: '/:institution',
        component: JHD_LAYOUT_TAG_NAME,
        action: async (context: RouteContext, commands: Commands) => {
            await import('../components/jhd-layout');
            return pageEnabled(context, commands, '/:institution/login');
        },
        children: [
            {
                path: '/dashboard',
                component: JHD_DASHBOARD_TAG_NAME,
                action: async () => {
                    await import('../dashboard/containers/dashboard');
                },
            },
            {
                path: '/accounts',
                component: ACCOUNTS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../accounts/containers/accounts-container');
                },
            },
            {
                path: '/accounts/research-transactions',
                component: ACCOUNTS_RESEARCH_TRANSACTIONS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../accounts/containers/accounts-research-transactions-container');
                },
            },
            {
                path: '/accounts/web-escrow',
                component: AGILETICS_WEB_ESCROW_CONTAINER_TAG_NAME,
                action: async (context: RouteContext, commands: Commands) => {
                    await import('../accounts/containers/agiletics-web-escrow-container');
                    return pageEnabled(context, commands, '/:institution/login');
                },
            },
            {
                path: '/accounts/:type/:id',
                component: ACCOUNT_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../accounts/containers/account-container');
                },
            },
            {
                path: '/accounts/:type/:accountId/transaction/:id',
                component: TRANSACTION_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../transaction/containers/transaction');
                },
            },
            {
                path: '/pending-approvals/:id',
                component: PENDING_APPROVALS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../pending-approvals/containers/pending-approvals-container');
                },
            },
            {
                path: '/ach/child-support/templates/:id',
                component: CHILD_SUPPORT_TEMPLATE_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/child-support/containers/child-support-template-container');
                },
            },
            {
                path: '/ach/child-support/templates',
                component: CHILD_SUPPORT_TEMPLATES_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/child-support/containers/child-support-templates-container');
                },
            },
            {
                path: '/ach/child-support/:type/:action/:id?',
                component: CHILD_SUPPORT_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/child-support/containers/child-support-workflow-container');
                },
            },
            {
                path: '/ach/child-support/:id',
                component: CHILD_SUPPORT_PAYMENT_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/child-support/containers/child-support-payment-container');
                },
            },
            {
                path: '/ach/child-support',
                component: CHILD_SUPPORT_PAYMENTS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/child-support/containers/child-support-payments-container');
                },
            },
            {
                path: '/ach/tax-payments/initiate',
                component: TAX_INITIATE_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/tax-payments/containers/tax-initiate-container');
                },
            },
            {
                path: '/ach/tax-payments/payment/create',
                component: TAX_PAYMENT_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/tax-payments/containers/tax-payment-workflow-container');
                },
            },
            {
                path: '/ach/tax-payments/template/clone/:id',
                component: TAX_TEMPLATE_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/tax-payments/containers/tax-template-workflow-container');
                },
            },
            {
                path: '/ach/tax-payments/template/create',
                component: TAX_TEMPLATE_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/tax-payments/containers/tax-template-workflow-container');
                },
            },
            {
                path: '/ach/tax-payments/template/:id',
                component: TAX_TEMPLATE_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/tax-payments/containers/tax-template-workflow-container');
                },
            },
            {
                path: '/ach/import-layout',
                component: ACH_IMPORT_LAYOUT_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/import-layout/containers/ach-import-layout-container');
                },
            },
            {
                path: '/ach/master-recipients',
                component: ACH_MASTER_RECIPIENTS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/containers/ach-master-recipients-container');
                },
            },
            {
                path: '/ach',
                component: ACH_PAYMENTS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/containers/ach-payments-container');
                },
            },
            {
                path: '/ach/batch/create',
                component: ACH_MANUAL_BATCH_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/containers/ach-manual-batch-container');
                },
            },
            {
                path: '/ach/batch/clone/:cloneId',
                component: ACH_MANUAL_BATCH_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/containers/ach-manual-batch-container');
                },
            },
            {
                path: '/ach/templates/:action?',
                component: ACH_TEMPLATES_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/containers/ach-templates-container');
                },
            },
            {
                path: '/ach/templates/:view/:id',
                component: ACH_TEMPLATE_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/containers/ach-template-container');
                },
            },
            {
                path: '/ach/reversal/:id',
                component: ACH_REVERSAL_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/containers/ach-reversal-container');
                },
            },
            {
                path: '/ach/:id',
                component: ACH_PAYMENT_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/containers/ach-payment-container');
                },
            },
            {
                path: '/ach/:type/:action/:id?',
                component: ACH_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../ach/containers/ach-workflow-container');
                },
            },
            {
                path: '/admin/users/user-list',
                component: COMPANY_USER_LIST_TAG_NAME,
                action: async () => {
                    await import('@treasury/domain-components/company-users/partials/company-user-list/company-user-list.component');
                },
            },
            {
                path: '/admin/users/new-user',
                component: COMPANY_USER_TAG_NAME,
                action: async () => {
                    await import('@treasury/domain-components/company-user/company-user.component');
                },
            },
            {
                path: '/admin/users/:userId',
                component: COMPANY_USER_TAG_NAME,
                action: async () => {
                    await import('@treasury/domain-components/company-user/company-user.component');
                },
            },
            {
                path: '/admin/account-nicknames',
                component: ACCOUNT_NICKNAMES_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../admin/containers/account-nicknames-container');
                },
            },
            {
                path: '/business-bill-pay',
                component: BUSINESS_BILL_PAY_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../business-bill-pay/containers/business-bill-pay-container');
                },
            },
            {
                path: '/business-bill-pay/payees',
                component: BUSINESS_BILL_PAY_PAYEES_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../business-bill-pay/containers/business-bill-pay-payees-container');
                },
            },
            {
                path: '/business-bill-pay/payment/:type/:id',
                component: BUSINESS_BILL_PAY_PAYMENT_DETAIL_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../business-bill-pay/containers/business-bill-pay-payment-detail-container');
                },
            },
            {
                path: '/business-bill-pay/payees/:id',
                component: BUSINESS_BILL_PAY_PAYEE_DETAIL_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../business-bill-pay/containers/business-bill-pay-payee-detail-container');
                },
            },
            {
                path: '/business-bill-pay/payments/:workflow/:id',
                component: BUSINESS_BILL_PAY_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../business-bill-pay/containers/business-bill-pay-workflow-container');
                },
            },
            {
                path: '/loans',
                component: LOANS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../loans/containers/loans-container');
                },
            },
            {
                path: '/loans/:id',
                component: LOAN_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../loans/containers/loan-container');
                },
            },
            {
                path: '/loans/:type/:action/:id',
                component: LOAN_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../loans/containers/loan-workflow-container');
                },
            },
            {
                path: '/transfers',
                component: TRANSFERS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../transfers/containers/transfers-container');
                },
            },
            {
                path: '/transfers/templates/:action?',
                component: TRANSFER_TEMPLATES_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../transfers/containers/transfer-templates-container');
                },
            },
            {
                path: '/transfers/template/:view/:id',
                component: TRANSFER_TEMPLATE_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../transfers/containers/transfer-template-container');
                },
            },
            { path: '/transfers/:id', component: 'transfer-container' },
            {
                path: '/transfers/:workflow/:action/:id/:type?',
                component: TRANSFER_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../transfers/containers/transfer-workflow-container');
                },
            },
            {
                path: '/wires',
                action: async (_: RouteContext, commands: Commands) => {
                    const di = await DiContainer.getInstance();
                    const featureFlagService = await di.getAsync(FeatureFlagService);
                    const useJhWires = await featureFlagService.isEnabled(Feature.UseJhWires);
                    if (useJhWires) {
                        await import('../wires/containers/jh-wires-container');
                    } else {
                        await import('../wires/containers/wires-container');
                    }
                    return useJhWires
                        ? commands.component(JH_WIRES_CONTAINER_TAG_NAME)
                        : commands.component(WIRES_CONTAINER_TAG_NAME);
                },
            },
            {
                path: '/wires/files',
                component: WIRE_FILES_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../wires/containers/wire-files-container');
                },
            },
            {
                path: '/wires/files/:id',
                component: WIRE_UPLOAD_FORMAT_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../wires/containers/wire-upload-format-container');
                },
            },
            {
                path: '/wires/multiple/creditors',
                component: CREDITORS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../wires/creditors/containers/creditors-container');
                },
            },
            {
                path: '/wires/creditors',
                component: CREDITORS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../wires/creditors/containers/creditors-container');
                },
            },
            {
                path: '/wires/creditors/view/:id',
                component: CREDITOR_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../wires/creditors/containers/creditor-container');
                },
            },
            {
                path: '/wires/creditors/:action/:id?',
                component: CREDITOR_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../wires/creditors/containers/creditor-workflow-container');
                },
            },
            {
                path: '/wires/:id',
                component: WIRE_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../wires/containers/wire-container');
                },
            },
            {
                path: '/wires/template/:id',
                component: WIRE_TEMPLATE_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../wires/templates/containers/wire-template-container');
                },
            },
            {
                path: '/wires/template/:action/:id/:currency?',
                component: WIRE_TEMPLATE_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../wires/templates/containers/wire-template-workflow-container');
                },
            },
            {
                path: '/wires/multiple/create',
                component: WIRES_MULTIPLE_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../wires/containers/wires-multiple-workflow-container');
                },
            },
            {
                path: '/wires/file/upload',
                component: WIRE_FILE_UPLOAD_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../wires/containers/wire-file-upload-workflow-container');
                },
            },
            {
                path: '/wires/fx/create',
                component: WIRES_FX_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../wires/containers/wires-fx-workflow-container');
                },
            },
            {
                path: '/wires/corpay',
                component: CORPAY_SSO_CONTAINER_TAG_NAME,
                action: async (context: RouteContext, commands: Commands) => {
                    await import('../wires/containers/corpay-sso-container');
                    return pageEnabled(context, commands, '/:institution/login');
                },
            },
            {
                path: '/wires/:type/:action/:id/:currency?',
                action: async (_: RouteContext, commands: Commands) => {
                    const di = await DiContainer.getInstance();
                    const featureFlagService = await di.getAsync(FeatureFlagService);
                    const useJhWires = await featureFlagService.isEnabled(Feature.UseJhWires);
                    if (useJhWires) {
                        await import('../wires/containers/jh-wires-workflow-container');
                    } else {
                        await import('../wires/containers/wires-workflow-container');
                    }
                    return useJhWires
                        ? commands.component(JH_WIRES_WORKFLOW_CONTAINER_TAG_NAME)
                        : commands.component(WIRES_WORKFLOW_CONTAINER_TAG_NAME);
                },
            },
            {
                path: '/wires/templates/:action?',
                component: WIRE_TEMPLATES_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../wires/templates/containers/wire-templates-container');
                },
            },
            {
                path: '/positive-pay/check-exceptions',
                component: CHECK_EXCEPTIONS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../positive-pay/check-exceptions/containers/check-exceptions-container');
                },
            },
            {
                path: '/positive-pay/check-exceptions/:id',
                component: CHECK_EXCEPTION_DETAIL_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../positive-pay/check-exceptions/containers/check-exception-detail-container');
                },
            },
            {
                path: '/positive-pay/ach-exceptions',
                component: ACH_EXCEPTIONS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../positive-pay/ach-exceptions/containers/ach-exceptions-container');
                },
            },
            {
                path: '/positive-pay/ach-filters/create',
                component: ACH_FILTER_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../positive-pay/ach-exceptions/containers/ach-filter-workflow-container');
                },
            },
            {
                path: '/positive-pay/ach-filters/:mode/:id',
                component: ACH_FILTER_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../positive-pay/ach-exceptions/containers/ach-filter-workflow-container');
                },
            },
            {
                path: '/positive-pay/centrix-sso',
                component: CENTRIX_SSO_CONTAINER_TAG_NAME,
                action: async (context: RouteContext, commands: Commands) => {
                    await import('../positive-pay/centrix-sso/containers/centrix-sso-container');
                    return pageEnabled(context, commands, '/:institution/login');
                },
            },
            {
                path: '/arp/issued-items-activity',
                component: ISSUED_ITEMS_ACTIVITY_CONTAINER_TAG_NAME,
                action: async (context: RouteContext, commands: Commands) => {
                    await import('../arp/issued-items-activity/containers/issued-items-activity-container');
                    return pageEnabled(context, commands);
                },
            },
            {
                path: '/arp/issued-items-file-activity',
                component: ISSUED_ITEMS_FILE_ACTIVITY_CONTAINER_TAG_NAME,
                action: async (context: RouteContext, commands: Commands) => {
                    await import('../arp/issued-items-file-activity/containers/issued-items-file-activity-container');
                    return pageEnabled(context, commands);
                },
            },
            {
                path: '/arp/issued-items-create',
                component: ISSUED_ITEMS_CREATE_CONTAINER_TAG_NAME,
                action: async (context: RouteContext, commands: Commands) => {
                    await import('../arp/issued-items-create/containers/issued-items-create-container');
                    return pageEnabled(context, commands);
                },
            },
            {
                path: '/stop-payments',
                component: STOP_PAYMENT_ACTIVITY_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../stop-payments/containers/stop-payment-activity-container');
                },
            },
            {
                path: '/stop-payments/:type/:workflow',
                component: STOP_PAYMENT_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../stop-payments/containers/stop-payment-workflow-container');
                },
            },
            {
                path: '/deposit',
                component: DEPOSIT_ACTIVITY_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../deposits/containers/deposit-activity-container');
                },
            },
            {
                path: '/create-deposit',
                component: DEPOSIT_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../deposits/containers/deposit-container');
                },
            },
            {
                path: '/edit-deposit/:id',
                component: DEPOSIT_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../deposits/containers/deposit-container');
                },
            },
            {
                path: '/message-center',
                component: MESSAGE_CENTER_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../message-center/containers/message-center-container');
                },
            },
            {
                path: '/message-center/compose',
                component: COMPOSE_MESSAGE_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../message-center/containers/compose-message-container');
                },
            },
            { path: '/message-center/:id', component: 'message-center-detail-container' },
            {
                path: '/notifications',
                component: NOTIFICATIONS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../notifications/containers/notifications-container');
                },
            },
            {
                path: '/about',
                component: ABOUT_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../about/containers/about-container');
                },
            },
            {
                path: '/log-out',
                component: LOGOUT_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../logout/containers/logout-container');
                },
            },
            {
                path: '/profile',
                component: USER_PROFILE_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../profile/containers/user-profile-container');
                },
            },
            {
                path: '/users/:id',
                component: USER_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../users/containers/user-container');
                },
            },
            {
                path: '/reports/electronic-documents',
                component: ELECTRONIC_DOCUMENTS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../reports/electronic-documents/electronic-documents-container');
                },
            },
            {
                path: '/reports/e-statements',
                component: ELECTRONIC_DOCUMENTS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../reports/electronic-documents/electronic-documents-container');
                },
            },
            {
                path: '/reports/bdi-e-statements',
                component: ELECTRONIC_DOCUMENTS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../reports/electronic-documents/electronic-documents-container');
                },
            },
            {
                path: '/reports',
                component: REPORT_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../reports/containers/report-container');
                },
                children: [
                    {
                        path: '/:type/:id',
                        component: REPORT_LAYOUT_TAG_NAME,
                        action: async () => {
                            await import('../reports/partials/report-layout');
                        },
                    },
                ],
            },
            {
                path: '/account-recon',
                component: ACCOUNT_RECON_REPORTS_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../account-recon/containers/account-recon-reports-container');
                },
            },
            {
                path: '/account-recon/library',
                component: ACCOUNT_RECON_LIBRARY_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../account-recon/containers/account-recon-library-container');
                },
            },
            {
                path: '/account-recon/workflow/:id?',
                component: ACCOUNT_RECON_WORKFLOW_CONTAINER_TAG_NAME,
                action: async () => {
                    await import('../account-recon/containers/account-recon-workflow-container');
                },
            },
        ],
    },
    {
        path: '(.*)',
        component: NOT_FOUND_TAG_NAME,
        action: async () => {
            await import('../components/not-found');
        },
    },
];
